<!-- @format -->
<script lang="ts">
    import type { ManageAPI } from "~/manage-api/types";
    export let store: ManageAPI.Store;
</script>

{#if store.isRestaurant && (store.restaurantInfo.foodoraUrl || store.restaurantInfo.woltUrl)}
<div class="px-5 align-items-center mb-5 d-flex justify-lg-content-between justify-content-center">
  {#if store.restaurantInfo.foodoraUrl}
    <a
      href={store.restaurantInfo.foodoraUrl}
      class="text-center"
      target="_blank"
      rel="noreferrer"
      >
      <img src="/theme/malloftripla2024/images/Foodora-logo.png" alt="Foodora" class="w-75" />
    </a>
  {/if}
  {#if store.restaurantInfo.woltUrl}
    <a href={store.restaurantInfo.woltUrl} class="text-center" target="_blank" rel="noreferrer">
      <img src="/theme/malloftripla2024/images/Wolt-logo.png" alt="Wolt" class="wolt" />
    </a>
  {/if}
</div>
{/if}
<div class="social-media-wrapper">
    {#if store.facebookURL}
      <a
        class="social-media purple-circle-button"
        href={store.facebookURL}
        target="_blank"
        rel="noreferrer"
      >
        <i class="bi bi-facebook d-flex" />
      </a>
    {/if}
    {#if store.twitterURL}
      <a
        class="social-media purple-circle-button"
        href={store.twitterURL}
        target="_blank"
        rel="noreferrer"
      >
        <i class="bi bi-twitter-x" />
      </a>
    {/if}
    {#if store.instagramURL}
      <a
        class="social-media purple-circle-button"
        href={store.instagramURL}
        target="_blank"
        rel="noreferrer"
      >
        <i class="bi bi-instagram d-flex" />
      </a>
    {/if}
    <br />
    <br />
    </div>

    <style lang="scss">
  .wolt {
    width: 50%;
    @media screen and (min-width: 992px) {
      width: 75%;
    }
  }
  .social-media-wrapper {
    display: flex;
    justify-content: center;
    .social-media {
      margin: 0 10px;
      margin-bottom: 60px;
    }
  }
    </style>